import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  TabPane,
  TabContent,
  NavLink,
  Spinner,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link, useNavigate, useParams } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import Overview from "./Overview";
import Tasks from "./Tasks";
import Team from "./Team";
import classnames from "classnames";

//import images
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import Attachments from "./Attachments";
import Objectives from "./Objectives";
import Financiers from "./Financiers";
import { useDispatch } from "react-redux";
import {
  deleteProject,
  getProjectById,
  getProjects,
} from "src/slices/Projects/thunk";
import { useSelector } from "react-redux";
import { AppDispatch } from "src";
import { formatDate } from "src/common/date-formater";
import { resetProject } from "src/slices/Projects/reducer";
import { formatNumber } from "src/helpers/format_helper";
import { getObjectivesByProject } from "src/slices/objectives/thunk";
import ProjectUpdate from "../ProjectUpdate";
import useToast from "src/components/Common/toast";
import DeleteProject from "../ProjectUpdate/delete";

import { useGetProjectByIdQuery } from "src/services/khozi";

const ProjectOverview = () => {
  document.title = "Visão Geral da Actividade - Khozi";
  const [menu, setMenu] = useState(false);
  const [menu1, setMenu1] = useState(false);

  const [activeTab, setactiveTab] = useState<string>("1");
  const [modal, setModal] = useState(false);
  const { show, ToastComponent } = useToast();
  const navigate = useNavigate();
  const [modalDelete, setModalDelete] = useState(false);
  const toggleDelete = () => setModalDelete(!modalDelete);

  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { data: project } = useGetProjectByIdQuery(id);
  const objectives = useSelector((state: any) => project?.objectives);
  //const statusPoints = useSelector((state: any) => project?.statusPoints);
  const toggleTab = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };
  useEffect(() => {
    dispatch(resetProject());
    dispatch(getProjectById(id));
    dispatch(getObjectivesByProject(id));
  }, [id]);

  const handleDelete = (id: number) => {
    dispatch(deleteProject(id)).then(response => {
      if (typeof response.payload === "undefined") {
        show("Erro", "Erro ao apagar actividade.");
      } else {
        show("Sucesso", "Actividade apagada com sucesso.");
        navigate("/projects");
        dispatch(getProjects());
      }
    });
    toggleDelete();
  };

  const totalContrato =
    project && project.tasks
      ? project.tasks.reduce((total: number, task: any) => {
          return total + (parseFloat(task.valor_estimado) || 0);
        }, 0)
      : 0;

  const totalGasto =
    project && project.tasks
      ? project.tasks.reduce((total: number, task: any) => {
          return total + (parseFloat(task.valor_gasto) || 0);
        }, 0)
      : 0;

  const saldo = project ? project.valor_previsto - totalGasto : 0;

  if (!project)
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner color="primary" />
      </div>
    );

  return (
    <React.Fragment>
      {ToastComponent}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Actividades" breadcrumbItem="Visão Geral da Actividade" titleLink="/projects"/>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="pb-0">
                  <Row>
                    <div className="col">
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                          <div className="avatar">
                            <div className="avatar-title bg-primary-subtle text-primary font-size-18 rounded">
                              {project.nome.slice(0, 1).toUpperCase()}
                            </div>
                          </div>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <div className="text-muted">
                            <h5 className="font-size-16 mb-1">{project.nome}</h5>
                            <p
                              className="mb-0"
                              style={{
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 1,
                              }}
                            >
                              {project.descricao}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-auto">
                      <div>
                        <div className="d-flex flex-wrap align-items-start justify-content-md-end gap-2 mb-3">
                          <div onClick={() => setModal(true)} className="btn btn-primary">
                            <i className="uil uil-pen"></i>
                          </div>
                          <div className="btn btn-secondary">
                            <i className="uil uil-comment-alt-edit"></i>
                          </div>
                          {/* <Dropdown isOpen={menu} toggle={() => setMenu(!menu)}>
                            <DropdownToggle className="btn btn-light" tag="a">
                              <i className="uil uil-bell"></i>
                              <span className="position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger p-1">
                                <span className="visually-hidden">
                                  mensagens não lidas
                                </span>
                              </span>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end dropdown-menu-lg">
                              <div className="px-3 py-2">
                                <div className="row align-items-center">
                                  <div className="col">
                                    <h5 className="font-size-15 m-0">
                                      {" "}
                                      Notifications{" "}
                                    </h5>
                                  </div>
                                  <div className="col-auto">
                                    <div className="badge bg-success rounded-pill">
                                      02
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <SimpleBar style={{ height: "190px" }}>
                                <Link to="#" className="dropdown-item p-3">
                                  <div className="d-flex align-items-start">
                                    <div className="flex-shrink-0 avatar-sm align-self-center me-3">
                                      <img
                                        src={avatar2}
                                        alt=""
                                        className="img-fluid rounded-circle"
                                      />
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                      <h5 className="font-size-13 mb-1">
                                        James Lemire
                                      </h5>
                                      <div className="font-size-12">
                                        <p className="text-muted text-truncate mb-0">
                                          If several languages coalesce the
                                          grammar
                                        </p>
                                      </div>
                                    </div>
                                    <p className="text-muted font-size-12 mb-0">
                                      <i className="mdi mdi-clock-outline"></i>{" "}
                                      3 Mins
                                    </p>
                                  </div>
                                </Link>
                              </SimpleBar>
                            </DropdownMenu>
                          </Dropdown> 
                          <Dropdown isOpen={menu1} toggle={() => setMenu1(!menu1)}>
                            <DropdownToggle className="btn btn-link text-dark shadow-none" color="">
                              <i className="uil uil-ellipsis-h"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                              <DropdownItem href="#">Adicionar Ponto de Situação</DropdownItem>
                              {/*<DropdownItem href="#">
                                Adicionar Objectivo
                              </DropdownItem>*
                              <DropdownItem divider />
                              <DropdownItem href="#" onClick={() => toggleDelete()} className="text-danger">
                                Apagar Actividade
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>*/}
                        </div>
                      </div>
                    </div>
                  </Row>
                  <Row>
                    <Col lg={4}>
                      <div className="mt-3">
                        <ul className="text-muted">
                          <li className="py-1">
                            Previsto:{" "}
                            <span className="text-dark fw-semibold">{formatNumber(project.valor_previsto)} MZN</span>
                          </li>
                          <li className="py-1">
                            Contrato:{" "}
                            <span className="text-dark fw-semibold">{formatNumber(totalContrato)} MZN</span>
                          </li>
                          <li className="py-1">
                            Saldo:{" "}
                            <span className="text-dark fw-semibold">{formatNumber(saldo)} MZN</span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col lg={8}>
                      <Row>
                        <Col lg={3} sm={6}>
                          <div className="d-flex align-items-center mt-4">
                            <div className="flex-shrink-0 me-3">
                              <i className="uil uil-calendar-alt text-primary font-size-22"></i>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-12 mb-1">Data de Início</h5>
                              <p className="text-muted mb-0">{formatDate(project.data_inicio)}</p>
                            </div>
                          </div>
                        </Col>
                        <Col lg={3} sm={6}>
                          <div className="d-flex align-items-center mt-4">
                            <div className="flex-shrink-0 me-3">
                              <i className="uil uil-check-circle text-primary font-size-22"></i>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-12 mb-1">Data de Término</h5>
                              <p className="text-muted mb-0">{formatDate(project.data_termino)}</p>
                            </div>
                          </div>
                        </Col>
                        <Col lg={2} sm={6}>
                          <div className="d-flex align-items-center mt-4">
                            <div className="flex-shrink-0 me-3">
                              <i className="uil uil-clock text-primary font-size-22"></i>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-12 mb-1">Duração</h5>
                              <p className="text-muted mb-0">{project.duracao} dias</p>
                            </div>
                          </div>
                        </Col>                        
                        <Col lg={2} sm={6}>
                          <div className="d-flex align-items-center mt-4">
                            <div className="flex-shrink-0 me-3">
                              <i className="uil uil-clipboard text-primary font-size-22"></i>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-12 mb-1">Estado</h5>
                              <p className="badge bg-warning mb-0">{project.status}</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <Nav className="nav-tabs nav-tabs-custom">
                      <NavItem>
                        <NavLink className={classnames({active: activeTab === "1",})} onClick={() => {toggleTab("1");}}>
                          Visão Geral
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={classnames({active: activeTab === "2",})} onClick={() => {toggleTab("2");}}>
                          Quantificação
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={classnames({active: activeTab === "3",})} onClick={() => {toggleTab("3");}}>
                          Fases
                        </NavLink>
                      </NavItem>
                      {/*<NavItem>
                        <NavLink className={classnames({active: activeTab === "4",})} onClick={() => {toggleTab("4");}}>
                          Equipa
                        </NavLink>
                      </NavItem>*/}
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === "5",
                          })}
                          onClick={() => {
                            toggleTab("5");
                          }}
                        >
                          Anexos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={classnames({active: activeTab === "6",})} onClick={() => {toggleTab("6");}}>
                          Financiadores
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </CardBody>
              </Card>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1"><Overview project={project} /></TabPane>
                <TabPane tabId="2"><Objectives project={project} objectives={objectives}/></TabPane>
                <TabPane tabId="3"><Tasks project={project} /></TabPane>
                <TabPane tabId="4"><Team project={project} /></TabPane>
                <TabPane tabId="5"><Attachments project={project} /></TabPane>
                <TabPane tabId="6"><Financiers project={project} /></TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
      <ProjectUpdate
        selectedProject={project}
        modal={modal}
        setModal={setModal}
        handleDelete={handleDelete}
        insideProjectOverview={true}
      />
      <DeleteProject
        modalDelete={modalDelete}
        toggleDelete={toggleDelete}
        handleDelete={handleDelete}
        selectedProject={project}
      />
    </React.Fragment>
  );
};

export default ProjectOverview;
